<template>
    <div class="write-offs-search">
        <div class="search-query">
            <v-text-field
                v-model="form.search"
                :label="$t('general.search')"
                append-icon="far fa-search"
                clear-icon="fal fa-times"
                clearable
                single-line
                hide-details
                @input="searchDebounce"
            />

            <v-btn
                v-if="!queryOnly"
                class="ml-3 mt-3"
                color="primary"
                icon
                @click="showForm = !showForm"
            >
                <v-icon>fal fa-filter</v-icon>
            </v-btn>
        </div>

        <v-slide-y-transition>
            <div
                v-if="showForm"
                class="search-form"
            >
                <v-row class="mt-1">
                    <v-col class="py-0" cols="8">
                        <v-select
                            v-model="form.countFilterType"
                            :items="filterTypes"
                            :error-messages="form.$errors.countFilterType"
                            :label="$t('stock.preview_by_stock')"
                            item-text="display"
                            item-value="value"
                            clear-icon="fal fa-times"
                            @blur="form.validate('countFilterType')"
                            @input="delete form.$errors.countFilterType"
                        />
                    </v-col>
                    <v-col class="py-0" cols="4">
                        <number-field
                            v-model="form.countFilterValue"
                            :error-messages="form.$errors.countFilterValue"
                            :label="$t('stock.in_stock')"
                            clearable
                            clear-icon="fal fa-times"
                            :disabled="showStockInput" 
                            @blur="form.validate('countFilterValue')"
                            @input="delete form.$errors.startDate"
                        />
                    </v-col>
                </v-row>

                <div class="d-flex justify-center mt-4">
                    <v-btn
                        color="primary"
                        outlined
                        @click="search"
                    >
                        {{ $t('general.search') }}
                    </v-btn>
                </div>
            </div>
        </v-slide-y-transition>
    </div>
</template>

<script>
import _ from 'lodash';
import { requiredIf } from 'vuelidate/lib/validators';
import NumberField from '@/components/NumberField.vue';

export default {

    components: {
        NumberField,
    },

    props: {
        filter: {
            type: Object,
            default: () => null
        },
        queryOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showForm: false,
            form: this.createForm(),
        };
    },

    validations() {
        return {
            form: {
                countFilterValue: { requiredIf: requiredIf(form => this.showForm && !this.showStockInput) },
                countFilterType: { requiredIf: requiredIf(form => this.showForm) },
            }
        }
    },
                
    watch: {
        filter(val) {
            this.form = this.createForm();
        },

        'form.countFilterType': function(newCountFilterType) {
            if (newCountFilterType === 'all') {
                this.form.$errors.countFilterValue = null;
                this.form.countFilterValue = null;
            }
        }
    },

    computed: {
        filterTypes() {
        return [
                { value: 'all', display: this.$t('stock.all') },
                { value: 'gt', display: this.$t('stock.greater_than') },
                { value: 'lt', display: this.$t('stock.less_than') },
                { value: 'equal', display: this.$t('stock.equal') }
            ]
        },

        showStockInput() {
            return this.form.countFilterType === 'all';
        },
        
    },

    methods: {
        createForm() {
            return new Form(this, 'form', {
                search: this.filter?.search || null,
                countFilterType: this.filter?.countFilterType || 'all',
                countFilterValue: this.filter?.countFilterValue || null,
            });
        },

        searchDebounce: _.debounce(function() {
            this.search();
        }, 500),

        search() {
            if(!this.form.validate()) return;
            this.showForm = false;

            const formData = this.form.toJson();

            this.$emit('update:filter', {
                search: formData.search,
                countFilterType: formData.countFilterType,
                countFilterValue: formData.countFilterValue,
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.write-offs-search {
    .search-query {
        display: flex;
        padding: 12px 0 20px 0;
        align-items: center;
    }

    .search-form {
        padding: 16px;
        border-radius: 3px;
        background: #fafafa;
        border: 1px solid #cccccc;
    }
}
</style>
